export default {
  beneficios: [],
  beneficio: {},
  semCBENEF: false,
};
